import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { PageProps, ReduxProps } from '../../../pages/explore/index';
import BusinessInductionBanner from '../../common/banners/BusinessInductionBanner';
import Button, { ButtonSize } from '../../common/buttons/Button';
import GlobalFooter from '../../common/layouts/GlobalFooter';
import GlobalNav from '../../common/layouts/GlobalNav/GlobalNav';
import ExploreCardContainer from '../common/cards/ExploreCardContainer';
import ExploreCategoryCard from '../common/cards/ExploreCategoryCard';
import ExploreMerchantCard from '../common/cards/ExploreMerchantCard';
import BizHeroSection from '../common/sections/BizHeroSection';
import ExploreHeroSection from '../common/sections/ExploreHeroSection';
import ExploreSection from '../common/sections/ExploreSection';
import ExploreSectionHead from '../common/sections/ExploreSectionHead';
import css from './ExploreIndexPage.module.scss';

type Props = PageProps & ReduxProps & InjectedIntlProps;

class ExploreIndexPage extends React.PureComponent<Props> {
  public render() {
    const {
      actions,
      explore,
      primaryCategories,
      popularMerchants,
      recentlyBookedMerchants,
      newMerchants,
      categories,
      intl,
    } = this.props;
    const intlPref = 'explore.index.';

    return (
      <div className={css.ExploreIndexPage}>
        <GlobalNav />

        <div className={css.ExploreIndexPage__Content}>
          <BizHeroSection />
          <ExploreHeroSection
            backgroudImageUrl={
              'https://d3jf92lm1e7l6.cloudfront.net/images/coubic/explore/hero-background.png'
            }
            copy={intl.formatMessage({ id: intlPref + 'hero.copy' })}
            copyTag={'h1'}
            subCopy={intl.formatMessage({ id: intlPref + 'hero.subCopy' })}
            searchModule={{ fieldData: explore.fieldData, actions }}
          />

          <ExploreSection>
            <ExploreSectionHead>
              {intl.formatMessage({ id: intlPref + 'sectionHeads.categories' })}
            </ExploreSectionHead>
            <ExploreCardContainer>
              {primaryCategories.map((cat, i) => (
                <ExploreCategoryCard category={cat} key={i} />
              ))}
            </ExploreCardContainer>
            <div className={css.ExploreIndexPage__SectionButtonContainer}>
              <Button
                buttonSize={ButtonSize.Medium}
                isGhost={true}
                className={css.ExploreIndexPage__SectionButton}
                href="/categories"
              >
                すべてのカテゴリーを見る
              </Button>
            </div>
          </ExploreSection>

          <ExploreSection>
            <ExploreSectionHead>
              {intl.formatMessage({
                id: intlPref + 'sectionHeads.popularMerchants',
              })}
            </ExploreSectionHead>
            <ExploreCardContainer>
              {popularMerchants.map((popularMerchant, i) => (
                <ExploreMerchantCard
                  merchant={popularMerchant.merchant}
                  merchantStations={popularMerchant.merchantStations}
                  key={i}
                />
              ))}
            </ExploreCardContainer>
          </ExploreSection>
          <ExploreSection>
            <ExploreSectionHead>
              {intl.formatMessage({
                id: intlPref + 'sectionHeads.recentlyBookedMerchants',
              })}
            </ExploreSectionHead>
            <ExploreCardContainer>
              {recentlyBookedMerchants.map((recentlyBookedMerchant, i) => (
                <ExploreMerchantCard
                  merchant={recentlyBookedMerchant.merchant}
                  merchantStations={recentlyBookedMerchant.merchantStations}
                  key={i}
                />
              ))}
            </ExploreCardContainer>
          </ExploreSection>

          <ExploreSection>
            <ExploreSectionHead>
              {intl.formatMessage({
                id: intlPref + 'sectionHeads.newMerchants',
              })}
            </ExploreSectionHead>
            <ExploreCardContainer>
              {newMerchants.map((newMerchant, i) => (
                <ExploreMerchantCard
                  merchant={newMerchant.merchant}
                  merchantStations={newMerchant.merchantStations}
                  key={i}
                />
              ))}
            </ExploreCardContainer>
          </ExploreSection>
          <BusinessInductionBanner />
        </div>

        <GlobalFooter categories={categories} />
      </div>
    );
  }
}

export default injectIntl(ExploreIndexPage);
